import Config from '../../config.json';

type ConfigKey = keyof typeof Config;

export function getEnvironmentVar(key: ConfigKey): string | undefined {
  const isLocalhost = process.env.NODE_ENV === 'development' || window.location.hostname.includes('efast.home.arpa');

  if (isLocalhost) {
    return process.env[key];
  }

  return Config[key];
}
